import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';
import { skipErrorHandler } from '../utils/http-helper';
import { DynamicFormDataConfig } from '../types/designer.types';

@Injectable({
  providedIn: 'root'
})
export class ValidatorRemoteService {
  constructor(private httpClient: HttpClient, private config: DynamicFormDesignerConfig) {
    this.httpClient = skipErrorHandler(this.httpClient);
  }

  get(url: string, params: HttpParams): Observable<any> {
    return this.httpClient.get(this.config.serviceUrl + url, { params: params });
  }

  validateUnique(
    value: any,
    dataSource: string,
    dataMemeber: string,
    dataConfig: DynamicFormDataConfig
  ): Observable<any> {
    const url = 'dynamicform/formdatas/unique';

    const params: any = {};
    params['value'] = value;
    params['dataEntityCode'] = dataSource;
    params['attrCode'] = dataMemeber;
    params['formCode'] = dataConfig.formCode;
    if (dataConfig.targetId) {
      params['excludeTargetId'] = dataConfig.targetId;
    }
    return this.get(url, params);
  }
}
